<div class="wccard p-3 mb-2 heightall" [ngClass]="shrinkdivonscroll ? 'shrinkdivonscrollclass': '' ">
  <div class="row">
    <div class="col-6" style="border-right: 1px solid #D5DEE6;">
      <div *ngIf="companyDetailsOne && !companyOneLoader">
        <div class="d-flex">
          <div>
            <div class="compLogoIcon mr-3 bg-gray-new">
              <i class="fa-solid fa-buildings text-webbtree-green" *ngIf="!companyDetailsOne?.companylogo"></i>
              <img [src]="companyDetailsOne?.companylogo" alt="companyDetailsOne?.name"
                *ngIf="companyDetailsOne?.companylogo">
            </div>
          </div>
          <div class="w-100">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex justify-content-between w-100">
                <div class="">
                  <p class="f-14 font-weight-600 text-484b59 mb-1" *ngIf="companyDetailsOne?.name">
                    {{companyDetailsOne?.name
                    |
                    titlecase}}</p>
                </div>
                <span class="text-webbtree-green">
                  <i class="far fa-times f-16 pointer" (click)="clearCompanyName('companyone', companyDetailsOne)"> </i>
                </span>

              </div>
            </div>
            <div>
              <p class="f-12 text-484b59 mb-1" *ngIf="companyDetailsOne?.industry">{{companyDetailsOne?.industry |
                titlecase}}
              </p>
              <div class="company-meta mb-2">
                <span matTooltip="Founded On" matTooltipClass="red-tooltip text-black"
                  *ngIf="companyDetailsOne?.founded">
                  <i class="fa-regular fa-flag mr-2"></i> {{ companyDetailsOne?.founded }}
                </span>

                <i class="fa-solid fa-circle" style="font-size:3px; color:#d9d9d9;"
                  *ngIf="companyDetailsOne?.founded && companyDetailsOne?.location?.name"></i>

                <span matTooltip="Location: {{companyDetailsOne?.location?.name}}"
                  matTooltipClass="red-tooltip text-black" class="text-truncate" style="max-width: 115px;"
                  *ngIf="companyDetailsOne?.location?.name">
                  <i class="fa-regular fa-buildings mr-2"></i> {{ companyDetailsOne?.location?.name | titlecase }}
                </span>

                <i class="fa-solid fa-circle" style="font-size:3px; color:#d9d9d9;"
                  *ngIf="companyDetailsOne?.size && companyDetailsOne?.location?.name"></i>

                <span matTooltip="Company Size" matTooltipClass="red-tooltip text-black"
                  *ngIf="companyDetailsOne?.size">
                  <i class="fa-regular fa-users mr-2"></i> {{ companyDetailsOne?.size }}
                </span>

                <i class="fa-solid fa-circle" style="font-size:3px; color:#d9d9d9;"
                  *ngIf="companyDetailsOne?.size && companyDetailsOne?.linkedin_url"></i>

                <span class="social-icons d-flex align-items-center">
                  <a data-testid="auto-app-company-comparison-overview-a-1" target="_blank" (click)="openUrl(companyDetailsOne?.linkedin_url, 'linkedin')"
                    *ngIf="companyDetailsOne?.linkedin_url">
                    <i class="fab fa-linkedin" style="color: #2F6DA7;"></i>
                  </a>
                  <a data-testid="auto-app-company-comparison-overview-a-2" target="_blank" (click)="openUrl(companyDetailsOne?.twitter_url, 'twitter')"
                    *ngIf="companyDetailsOne?.twitter_url">
                    <i class="fa-brands fa-square-x-twitter" style="color: #000000;"></i>
                  </a>
                  <a data-testid="auto-app-company-comparison-overview-a-3" target="_blank" (click)="openUrl(companyDetailsOne?.facebook_url, 'facebook')"
                    *ngIf="companyDetailsOne?.facebook_url">
                    <i class="fab fa-facebook" style="color: #2F6DA7;"></i>
                  </a>
                  <a data-testid="auto-app-company-comparison-overview-a-4" target="_blank" (click)="openUrl(companyDetailsOne?.website, 'website')" *ngIf="companyDetailsOne?.website">
              <i class="fas fa-globe text-webbtree-green ml-2"></i>
            </a>
                </span>
              </div>

            </div>
          </div>
        </div>
        <div>
          <button data-testid="auto-app-company-comparison-overview-button-1" class="btn-trms-regular w-100" (click)="redirecttoCompanylist(companyDetailsOne)">
            View Insights
          </button>
        </div>

        <div class="compDetail pt-3 pb-2">
          <div class="f-12 align-items-center" style="line-height: 1.7;">
            <div *ngIf="companyDetailsOne?.headline">
              <i class="fa-regular fa-hand-peace mr-2"></i>
              <span>{{companyDetailsOne?.headline | titlecase }}</span>
            </div>
            <span *ngIf="companyDetailsOne?.type"><i class="fa-regular fa-users mr-2"></i>
              <span>{{companyDetailsOne?.type | titlecase}}</span></span>
            <i class="fa-solid fa-circle mx-2" style="font-size:4px; color: #2E93A1;"
              *ngIf="companyDetailsOne?.type && companyDetailsOne?.total_funding_raised"></i>
            <span *ngIf="companyDetailsOne?.total_funding_raised"><i
                class="fa-regular fa-hand-holding-circle-dollar mr-2"></i>
              <span>${{formatNumberToIndianFormat(companyDetailsOne?.total_funding_raised)}} Raised</span></span>
            <i class="fa-solid fa-circle mx-2" style="font-size:4px; color: #2E93A1;"
              *ngIf="companyDetailsOne?.total_funding_raised && companyDetailsOne?.number_funding_rounds && !companyDetailsOne?.total_funding_raised"></i>
            <i class="fa-solid fa-circle mx-2" style="font-size:4px; color: #2E93A1;"
              *ngIf="companyDetailsOne?.type && companyDetailsOne?.number_funding_rounds"></i>

            <span *ngIf="companyDetailsOne?.number_funding_rounds"><i class="fa-solid fa-stairs mr-2"></i>
              <span>{{companyDetailsOne?.number_funding_rounds}} funding rounds </span></span>
            <i class="fa-solid fa-circle mx-2" style="font-size:4px; color: #2E93A1;"
              *ngIf="(companyDetailsOne?.number_funding_rounds && companyDetailsOne?.latest_funding_stage) ||
              (companyDetailsOne?.type && companyDetailsOne?.latest_funding_stage && !companyDetailsOne?.total_funding_raised) ||
              (companyDetailsOne?.total_funding_raised && companyDetailsOne?.latest_funding_stage && !companyDetailsOne?.type)"></i>


            <span *ngIf="companyDetailsOne?.latest_funding_stage"><i class="fa-regular fa-seedling mr-2"></i>
              <span>{{companyDetailsOne?.latest_funding_stage | titlecase}}</span></span>
          </div>
        </div>
        <hr class="mt-0 mb-0" />
        <div *ngIf="companyDetailsOne?.summary" class="f-12 textBox">
          <span>
            {{ displaySummaryCompanyOne }}
            <ng-container *ngIf="!viewMore && companyDetailsOne.summary.length > maxLength">...</ng-container>
            <span class="text-webbtree-green pointer ml-1" *ngIf="companyDetailsOne.summary.length > maxLength"
              (click)="viewMore = !viewMore">
              {{ viewMore ? 'View Less' : 'View More' }}
            </span>
          </span>
        </div>
        <hr class="mt-0 mb-3" />
        <div class="d-flex flex-wrap align-items-center" style="gap: 8px;">
          <!-- Displayed tags -->
          <span *ngFor="let tag of visibleTagsCompanyOne" class="tagslabel">
            <span class="tagicon"><i class="fas fa-tag"></i></span>
            <span class="text-truncate">{{ tag | titlecase }}</span>
          </span>
          <span *ngIf="!viewMoreTagsCompanyOne && hiddenTagCountCompanyOne > 0" class="text-webbtree-green pointer"
            (click)="viewMoreTagsCompanyOne = true">
            + {{ hiddenTagCountCompanyOne }} Tags
          </span>
          <span *ngIf="viewMoreTagsCompanyOne && companyOneTags?.length > tagDisplayLimit"
            class="text-webbtree-green pointer" (click)="viewMoreTagsCompanyOne = false">
            View Less
          </span>
        </div>



      </div>
      <div *ngIf="!companyDetailsOne">
        <div class="addCompany-empty" *ngIf="!companyOneLoader" (click)="openAddCompanyModal('companyone')">
          <p class="f-14 font-weight-500 pointer">Click here to add company.</p>
        </div>

      </div>
      <div *ngIf="companyOneLoader">
        <app-comparison-skeleton-loader *ngIf="companyOneLoader"
          [type]="'companyLoader'"></app-comparison-skeleton-loader>

      </div>

    </div>
    <div class="col-6">
      <div *ngIf="companyDetailsTwo && !companyTwoLoader">
        <div class="d-flex">
          <div>
            <div class="compLogoIcon mr-3 bg-gray-new">
              <i class="fa-solid fa-buildings text-webbtree-green" *ngIf="!companyDetailsTwo?.companylogo"></i>
              <img [src]="companyDetailsTwo?.companylogo" alt="companyDetailsTwo?.name"
                *ngIf="companyDetailsTwo?.companylogo">
            </div>
          </div>
          <div class="w-100">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex justify-content-between w-100">
                <div class="">
                  <p class="f-14 font-weight-600 text-484b59 mb-1" *ngIf="companyDetailsTwo?.name">
                    {{companyDetailsTwo?.name |
                    titlecase}}</p>
                </div>
                <span class="text-webbtree-green">
                  <i class="far fa-times f-16 pointer" (click)="clearCompanyName('companytwo', companyDetailsTwo)"> </i>
                </span>
              </div>
            </div>
            <div>
              <p class="f-12 text-484b59 mb-1" *ngIf="companyDetailsTwo?.industry">{{companyDetailsTwo?.industry |
                titlecase}}
              </p>
              <div class="company-meta mb-2">
                <span matTooltip="Founded On" matTooltipClass="red-tooltip texz" *ngIf="companyDetailsTwo?.founded">
                  <i class="fa-regular fa-flag mr-2"></i> {{ companyDetailsTwo?.founded }}
                </span>

                <i class="fa-solid fa-circle" style="font-size:3px; color:#d9d9d9;"
                  *ngIf="companyDetailsTwo?.founded && companyDetailsTwo?.location?.name"></i>

                <span matTooltip="Location: {{companyDetailsTwo?.location?.name}}"
                  matTooltipClass="red-tooltip text-black" class="text-truncate" style="max-width: 115px;"
                  *ngIf="companyDetailsTwo?.location?.name">
                  <i class="fa-regular fa-buildings mr-2"></i> {{ companyDetailsTwo?.location?.name | titlecase }}
                </span>

                <i class="fa-solid fa-circle" style="font-size:3px; color:#d9d9d9;"
                  *ngIf="companyDetailsTwo?.size && companyDetailsTwo?.location?.name"></i>

                <span matTooltip="Company Size" matTooltipClass="red-tooltip text-black"
                  *ngIf="companyDetailsTwo?.size">
                  <i class="fa-regular fa-users mr-2"></i> {{ companyDetailsTwo?.size }}
                </span>

                <i class="fa-solid fa-circle" style="font-size:3px; color:#d9d9d9;"
                  *ngIf="companyDetailsTwo?.size && companyDetailsTwo?.linkedin_url"></i>

                <span class="social-icons d-flex align-items-center">
                  <a data-testid="auto-app-company-comparison-overview-a-5" target="_blank" (click)="openUrl(companyDetailsTwo?.linkedin_url, 'linkedin')"
                    *ngIf="companyDetailsTwo?.linkedin_url">
                    <i class="fab fa-linkedin" style="color: #2F6DA7;"></i>
                  </a>
                  <a data-testid="auto-app-company-comparison-overview-a-6" target="_blank" (click)="openUrl(companyDetailsTwo?.twitter_url, 'twitter')"
                    *ngIf="companyDetailsTwo?.twitter_url">
                    <i class="fa-brands fa-square-x-twitter" style="color: #000000;"></i>
                  </a>
                  <a data-testid="auto-app-company-comparison-overview-a-7" target="_blank" (click)="openUrl(companyDetailsTwo?.facebook_url, 'facebook')"
                    *ngIf="companyDetailsTwo?.facebook_url">
                    <i class="fab fa-facebook" style="color: #2F6DA7;"></i>
                  </a>
                   <a data-testid="auto-app-company-comparison-overview-a-8" target="_blank" (click)="openUrl(companyDetailsTwo?.website, 'website')" *ngIf="companyDetailsTwo?.website">
                      <i class="fas fa-globe text-webbtree-green ml-2"></i>
                    </a>
                </span>
              </div>

            </div>
          </div>
        </div>
        <div>
          <button data-testid="auto-app-company-comparison-overview-button-2" class="btn-trms-regular w-100" (click)="redirecttoCompanylist(companyDetailsTwo)">
            View Insights
          </button>
        </div>

        <div class="compDetail pt-3 pb-2">
          <div class="f-12 align-items-center" style="line-height: 1.7;">
            <div *ngIf="companyDetailsTwo?.headline">
              <i class="fa-regular fa-hand-peace mr-2"></i>
              <span>{{companyDetailsTwo?.headline | titlecase}}</span>
            </div>
            <span *ngIf="companyDetailsTwo?.type"><i class="fa-regular fa-users mr-2"></i>
              <span>{{companyDetailsTwo?.type | titlecase}}</span></span>
            <i class="fa-solid fa-circle mx-2" style="font-size:4px; color: #2E93A1;"
              *ngIf="companyDetailsTwo?.type && companyDetailsTwo?.total_funding_raised"></i>
            <span *ngIf="companyDetailsTwo?.total_funding_raised"><i
                class="fa-regular fa-hand-holding-circle-dollar mr-2"></i>
              <span>${{formatNumberToIndianFormat(companyDetailsTwo?.total_funding_raised)}} Raised</span></span>
            <i class="fa-solid fa-circle mx-2" style="font-size:4px; color: #2E93A1;"
              *ngIf="companyDetailsTwo?.total_funding_raised && companyDetailsTwo?.number_funding_rounds && !companyDetailsTwo?.total_funding_raised"></i>
            <i class="fa-solid fa-circle mx-2" style="font-size:4px; color: #2E93A1;"
              *ngIf="companyDetailsTwo?.type && companyDetailsTwo?.number_funding_rounds"></i>

            <span *ngIf="companyDetailsTwo?.number_funding_rounds"><i class="fa-solid fa-stairs mr-2"></i>
              <span>{{companyDetailsTwo?.number_funding_rounds}} funding rounds </span></span>
            <i class="fa-solid fa-circle mx-2" style="font-size:4px; color: #2E93A1;"
              *ngIf="companyDetailsTwo?.number_funding_rounds && companyDetailsTwo?.latest_funding_stage"></i>
            <i class="fa-solid fa-circle mx-2" style="font-size:4px; color: #2E93A1;"
              *ngIf="companyDetailsTwo?.type && companyDetailsTwo?.latest_funding_stage && !companyDetailsTwo?.total_funding_raised"></i>
            <i class="fa-solid fa-circle mx-2" style="font-size:4px; color: #2E93A1;"
              *ngIf="companyDetailsTwo?.total_funding_raised && companyDetailsTwo?.latest_funding_stage && !companyDetailsTwo?.type"></i>

            <span *ngIf="companyDetailsTwo?.latest_funding_stage"><i class="fa-regular fa-seedling mr-2"></i>
              <span>{{companyDetailsTwo?.latest_funding_stage | titlecase}}</span></span>
          </div>
        </div>
        <hr class="mt-0 mb-0" />
        <div *ngIf="companyDetailsTwo?.summary" class="f-12 textBox">
          <span>
            {{ displaySummaryCompanyTwo }}
            <ng-container
              *ngIf="!viewMoreCompanyTwo && companyDetailsTwo?.summary?.length > maxLength">...</ng-container>
            <span class="text-webbtree-green pointer ml-1" *ngIf="companyDetailsTwo.summary.length > maxLength"
              (click)="viewMoreCompanyTwo = !viewMoreCompanyTwo">
              {{ viewMoreCompanyTwo ? 'View Less' : 'View More' }}
            </span>
          </span>
        </div>
        <hr class="mt-0 mb-3" />
        <div class="d-flex flex-wrap align-items-center" style="gap: 8px;">
          <!-- Displayed tags -->
          <span *ngFor="let tag of visibleTagsCompanyTwo" class="tagslabel">
            <span class="tagicon"><i class="fas fa-tag"></i></span>
            <span class="text-truncate">{{ tag | titlecase }}</span>
          </span>
          <span *ngIf="!viewMoreTagsCompanyTwo && hiddenTagCountCompanyTwo > 0" class="text-webbtree-green pointer"
            (click)="viewMoreTagsCompanyTwo = true">
            + {{ hiddenTagCountCompanyTwo }} Tags
          </span>
          <span *ngIf="viewMoreTagsCompanyTwo && companyTwoTags?.length > tagDisplayLimit"
            class="text-webbtree-green pointer" (click)="viewMoreTagsCompanyTwo = false">
            View Less
          </span>
        </div>
      </div>
      <div *ngIf="!companyDetailsTwo">
        <div class="addCompany-empty" *ngIf="!companyTwoLoader" (click)="openAddCompanyModal('companytwo')">
          <p class="f-14 font-weight-500 pointer">+Click here to add company</p>
        </div>


      </div>
      <div *ngIf="companyTwoLoader">
        <app-comparison-skeleton-loader *ngIf="companyTwoLoader"
          [type]="'companyLoader'"></app-comparison-skeleton-loader>

      </div>

    </div>
  </div>
</div>
<div [ngClass]="shrinkdivonscroll ? 'mt-100': '' ">

  <div class="wccard p-2 mb-2">
    <app-company-comparison-ai (sendAISummary)="getAISummary($event)"></app-company-comparison-ai>
  </div>
  <div class="wccard mb-2">
    <!-- key highlights -->
    <div class="d-flex justify-content-center align-items-center p-2"
      style="background-color: #FBFBFB;border: 1px solid #D9D9D9;">
      <p class="f-14 font-weight-500 mb-0">Key Highlights</p>
    </div>
    <div class="row"
    [ngStyle]="{'height':!totalResultCountCompanyOne && !medianTanuresCompanyOneCount && !totalResultCountCompanyTwo && !medianTenureCompanyTwoCount && !keyProfessionalTwoLoader ?  '100px': ''}">
      <div class="col-6" style="border-right: 1px solid #D5DEE6;">
        <div *ngIf="!totalResultCountCompanyOne && !medianTanuresCompanyOneCount">

          <app-comparison-skeleton-loader *ngIf="keyProfessionalOneLoader && locationCompanyOneLoader" style="height: 100px;"
            [type]="'keyProfesional'"></app-comparison-skeleton-loader>
        </div>
        <div class="text-center mx-auto my-3" *ngIf="!keyProfessionalOneLoader && !locationCompanyOneLoader">
          <div class="d-flex justify-content-center">
            <div class="text-left w-50">
              <p class="mb-0 d-flex align-items-center">
                <span class="font-weight-600 f-12">
                  {{totalResultCountCompanyOne ? totalResultCountCompanyOne: '0'}}
                </span>
              </p>
              <p class=" text-9696 mb-0" style="font-size: 10px;">Professionals<i class="fa-regular fa-info-circle ml-1"
                  matTooltip="The total number of professionals within the company."
                  [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
            </div>
            <div class="text-left">
              <p class="mb-0 d-flex align-items-center">
                <span class="f-12 font-weight-600"
                  [innerHTML]="getFormattedTenureForMatrix(medianTanuresCompanyOneCount)">
                </span>
              </p>
              <p class="text-9696 mb-0" style="font-size: 10px;">Median Tenure <i class="fa-regular fa-info-circle ml-1"
                  matTooltip="Median Tenure of the talent" [matTooltipClass]="{ 'red-tooltip text-black': true }"></i>
              </p>
            </div>
          </div>

        </div>
      </div>
      <div class="col-6">
        <div *ngIf="!totalResultCountCompanyTwo && !medianTenureCompanyTwoCount">

          <app-comparison-skeleton-loader *ngIf="keyProfessionalTwoLoader && locationCompanyTwoLoader" style="height: 100px;"
            [type]="'keyProfesional'"></app-comparison-skeleton-loader>


        </div>
        <div class="text-center mx-auto my-3" *ngIf="!keyProfessionalTwoLoader">
          <div class="d-flex justify-content-center">
            <div class="text-left w-50">
              <p class="mb-0 d-flex align-items-center">
                <span class="font-weight-600 f-12">
                  {{totalResultCountCompanyTwo ? totalResultCountCompanyTwo: '0'}}
                </span>
              </p>
              <p class=" text-9696 mb-0" style="font-size: 10px;">Professionals<i class="fa-regular fa-info-circle ml-1"
                  matTooltip="The total number of professionals within the company."
                  [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
            </div>
            <div class="text-left">
              <p class="mb-0 d-flex align-items-center">
                <span class="f-12 font-weight-600"
                  [innerHTML]="getFormattedTenureForMatrix(medianTenureCompanyTwoCount)">
                </span>
              </p>
              <p class="text-9696 mb-0" style="font-size: 10px;">Median Tenure <i class="fa-regular fa-info-circle ml-1"
                  matTooltip="Median Tenure of the talent" [matTooltipClass]="{ 'red-tooltip text-black': true }"></i>
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- Talent Movement -->
    <div class="d-flex justify-content-center align-items-center p-2"
      style="background-color: #FBFBFB;border: 1px solid #D9D9D9;">
      <p class="f-14 font-weight-500 mb-0 mr-2">Talent Movement
        <i class="fa-regular fa-circle-info f-12 custom-tooltip"
          matTooltip=" Hiring and attrition trends over the past year, helping you assess workforce stability or change."
          [matTooltipClass]="{ 'ai-tooltip text-black': true }"></i>

      </p>
    </div>
    <div class="row mx-0"
      [ngStyle]="{'height':winningCompanyTrends?.length == 0 && loosingCompanyTrends?.length == 0 && winningTrendsCompanyTwo?.length == 0 && loosingTrendsCompanyTwo?.length == 0 && !talentMovementCompanyOneLoaader ?  '100px': ''}">
      <div class="col-6 py-3"
        [ngClass]="{'d-flex justify-content-center align-items-center talent-empty': winningCompanyTrends?.length == 0 && loosingCompanyTrends?.length == 0 && !hiresAndAttritionObj?.recentGrowth?.currentYearCount && !hiresAndAttritionObj?.recentAttrtion?.currentYearCount && !talentMovementCompanyOneLoaader}"
        style="border-right: 1px solid #D5DEE6;">
        <div style="position: absolute;"
          *ngIf="winningCompanyTrends?.length == 0 && loosingCompanyTrends?.length == 0 && !hiresAndAttritionObj?.recentGrowth?.currentYearCount && !hiresAndAttritionObj?.recentAttrtion?.currentYearCount">


          <div *ngIf="!talentMovementCompanyOneLoaader">
            <p class="text-center p-5">No Data Available</p>
          </div>
        </div>
        <div *ngIf="talentMovementCompanyOneLoaader" style="height: 200px;">
          <app-comparison-skeleton-loader [type]="'talenMovementLoader'"></app-comparison-skeleton-loader>

        </div>

        <div
          *ngIf="!talentMovementCompanyOneLoaader && (hiresAndAttritionObj?.recentGrowth?.currentYearCount != 0 || hiresAndAttritionObj?.recentAttrtion?.currentYearCount != 0) && (winningCompanyTrends?.length || loosingCompanyTrends?.length)">
          <div class="text-center mx-auto my-3"
            *ngIf="hiresAndAttritionObj?.recentGrowth?.currentYearCount != 0 || hiresAndAttritionObj?.recentAttrtion?.currentYearCount != 0">
            <div class="d-flex justify-content-center">
              <div class="text-left w-50 pointer" *ngIf="hiresAndAttritionObj?.recentGrowth" (click)="handleRedirection('recentGrowth', null, 'companyone')">
                <p class="mb-0 d-flex align-items-center">
                  <span class="font-weight-600 f-12">
                    {{hiresAndAttritionObj?.recentGrowth?.currentYearCount ?
                    hiresAndAttritionObj?.recentGrowth?.currentYearCount : '0'}}
                  </span>
                  <i class="fa-solid fa-caret-up f-10 mr-1"
                    *ngIf="hiresAndAttritionObj?.recentGrowth?.increaseRate && hiresAndAttritionObj?.recentGrowth?.currentYearCount"
                    [ngClass]="{ 'fa-rotate-180 mb-1': hiresAndAttritionObj?.recentGrowth?.increaseRate < 0, 'text-danger': hiresAndAttritionObj?.recentGrowth?.increaseRate < 0, 'text-success': hiresAndAttritionObj?.recentGrowth?.increaseRate > 0 }"></i>
                </p>
                <p class=" text-9696 mb-0" style="font-size: 10px;">Recent Hires (1 Yr)</p>
              </div>
              <div class="text-left pointer" *ngIf="hiresAndAttritionObj?.recentAttrtion" (click)="handleRedirection('recentAttrtion', null, 'companyone')">
                <p class="mb-0 d-flex align-items-center">
                  <span class="f-12 font-weight-600">
                    {{hiresAndAttritionObj?.recentAttrtion?.currentYearCount ?
                    hiresAndAttritionObj?.recentAttrtion?.currentYearCount : '0'}}

                  </span>
                  <i class="fa-solid fa-caret-up f-10 mr-1"
                    *ngIf="hiresAndAttritionObj?.recentAttrtion?.increaseRate && hiresAndAttritionObj?.recentAttrtion?.currentYearCount"
                    [ngClass]="{ 'fa-rotate-180 mb-1':  hiresAndAttritionObj?.recentAttrtion?.increaseRate < 0, 'text-danger': hiresAndAttritionObj?.recentAttrtion?.increaseRate < 0, 'text-success': hiresAndAttritionObj?.recentAttrtion?.increaseRate > 0 }">
                  </i>
                </p>
                <p class="text-9696 mb-0" style="font-size: 10px;">Recent Attrition (1 Yr) </p>
              </div>
            </div>

          </div>
          <div>
            <div class="text-center">
              <div class="col">



                <div *ngIf="winningCompanyTrends?.length || loosingCompanyTrends?.length">
                  <fusioncharts height="450" width="100%" type="stackedcolumn2dline"
                    *ngIf="hireDepartureTalentDataSource" [dataSource]="hireDepartureTalentDataSource"></fusioncharts>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="col-6 py-3"
        [ngClass]="{'d-flex justify-content-center align-items-center talent-empty': winningTrendsCompanyTwo?.length == 0 && loosingTrendsCompanyTwo?.length == 0 && !hiresAndAttritionObjCompanyTwo?.recentGrowth?.currentYearCount && !hiresAndAttritionObjCompanyTwo?.recentAttrtion?.currentYearCount && !talentMovementCompanyTwoLoaader}">
        <div style="position: absolute;"
          *ngIf="winningTrendsCompanyTwo?.length == 0 && loosingTrendsCompanyTwo?.length == 0 && !hiresAndAttritionObjCompanyTwo?.recentGrowth?.currentYearCount && !hiresAndAttritionObjCompanyTwo?.recentAttrtion?.currentYearCount">

          <div *ngIf="!talentMovementCompanyTwoLoaader">
            <p class="text-center p-5">No Data Available</p>
          </div>
        </div>
        <div *ngIf="talentMovementCompanyTwoLoaader" style="height: 200px;">
          <app-comparison-skeleton-loader *ngIf="talentMovementCompanyTwoLoaader"
            [type]="'talenMovementLoader'"></app-comparison-skeleton-loader>
        </div>
        <!-- <div class="col text-center my-3"
        *ngIf="hiresAndAttritionObjCompanyTwo?.recentGrowth?.currentYearCount != 0 || hiresAndAttritionObjCompanyTwo?.recentAttrtion?.currentYearCount != 0">
        <div class="talent-hires d-flex justify-content-center">
          <div class="text-left w-50" *ngIf="hiresAndAttritionObjCompanyTwo?.recentGrowth">
            <p *ngIf="!hiresAndAttritionObjCompanyTwo?.recentGrowth?.increaseRate">
              <i class="fa-solid fa-dash mt-2 mb-2"></i>
            </p>
            <p class="mb-0 d-flex align-items-center"
              *ngIf="hiresAndAttritionObjCompanyTwo?.recentGrowth?.increaseRate">
              <span class="font-weight-600 f-12">
                {{hiresAndAttritionObjCompanyTwo?.recentGrowth?.currentYearCount}}
              </span>

              <i class="fa-solid fa-caret-up f-10 mr-1"
                *ngIf="hiresAndAttritionObjCompanyTwo?.recentGrowth?.increaseRate && hiresAndAttritionObjCompanyTwo?.recentGrowth?.currentYearCount"
                [ngClass]="{ 'fa-rotate-180 mb-1': hiresAndAttritionObjCompanyTwo?.recentGrowth?.increaseRate < 0, 'text-danger': hiresAndAttritionObjCompanyTwo?.recentGrowth?.increaseRate < 0, 'text-success': hiresAndAttritionObjCompanyTwo?.recentGrowth?.increaseRate > 0 }"></i>
            </p>
            <p class=" text-9696 mb-0" style="font-size: 10px;">Recent Hires (1 Yr)</p>
          </div>
          <div class="text-left" *ngIf="hiresAndAttritionObjCompanyTwo?.recentAttrtion">
            <p *ngIf="!hiresAndAttritionObjCompanyTwo?.recentAttrtion?.increaseRate">
              <i class="fa-solid fa-dash mt-2 mb-2"></i>
            </p>
            <p class="mb-0 d-flex align-items-center"
              *ngIf="hiresAndAttritionObjCompanyTwo?.recentAttrtion?.increaseRate">
              <span class="f-12 font-weight-600">
                {{hiresAndAttritionObjCompanyTwo?.recentAttrtion?.currentYearCount}}
              </span>
              <i class="fa-solid fa-caret-up f-10 mr-1"
                *ngIf="hiresAndAttritionObjCompanyTwo?.recentAttrtion?.increaseRate && hiresAndAttritionObjCompanyTwo?.recentAttrtion?.currentYearCount"
                [ngClass]="{ 'fa-rotate-180 mb-1':  hiresAndAttritionObjCompanyTwo?.recentAttrtion?.increaseRate < 0, 'text-danger': hiresAndAttritionObjCompanyTwo?.recentAttrtion?.increaseRate < 0, 'text-success': hiresAndAttritionObjCompanyTwo?.recentAttrtion?.increaseRate > 0 }">
              </i>
            </p>
            <p class="text-9696 mb-0" style="font-size: 10px;"> Recent Attrition (1 Yr) </p>
          </div>
        </div>

      </div> -->
        <div
          *ngIf="!talentMovementCompanyTwoLoaader && (hiresAndAttritionObjCompanyTwo?.recentGrowth?.currentYearCount != 0 || hiresAndAttritionObjCompanyTwo?.recentAttrtion?.currentYearCount != 0) && (winningTrendsCompanyTwo?.length || loosingTrendsCompanyTwo?.length) && hireDepartureTalentDataSourceTwo != {}">
          <div class="text-center mx-auto my-3 col"
            *ngIf="hiresAndAttritionObjCompanyTwo?.recentGrowth?.currentYearCount != 0 || hiresAndAttritionObjCompanyTwo?.recentAttrtion?.currentYearCount != 0">
            <div class="d-flex justify-content-center">
              <div class="text-left w-50 pointer" *ngIf="hiresAndAttritionObjCompanyTwo?.recentGrowth" (click)="handleRedirection('recentGrowth', null, 'companytwo')">
                <p class="mb-0 d-flex align-items-center">
                  <span class="font-weight-600 f-12">
                    {{hiresAndAttritionObjCompanyTwo?.recentGrowth?.currentYearCount ?
                    hiresAndAttritionObjCompanyTwo?.recentGrowth?.currentYearCount : '0'}}
                  </span>
                  <i class="fa-solid fa-caret-up f-10 mr-1"
                    *ngIf="hiresAndAttritionObjCompanyTwo?.recentGrowth?.increaseRate && hiresAndAttritionObjCompanyTwo?.recentGrowth?.currentYearCount"
                    [ngClass]="{ 'fa-rotate-180 mb-1': hiresAndAttritionObjCompanyTwo?.recentGrowth?.increaseRate < 0, 'text-danger': hiresAndAttritionObjCompanyTwo?.recentGrowth?.increaseRate < 0, 'text-success': hiresAndAttritionObjCompanyTwo?.recentGrowth?.increaseRate > 0 }"></i>
                </p>
                <p class=" text-9696 mb-0" style="font-size: 10px;">Recent Hires (1 Yr)</p>
              </div>
              <div class="text-left pointer" *ngIf="hiresAndAttritionObjCompanyTwo?.recentAttrtion" (click)="handleRedirection('recentAttrtion', null, 'companytwo')">
                <p class="mb-0 d-flex align-items-center">
                  <span class="f-12 font-weight-600">
                    {{hiresAndAttritionObjCompanyTwo?.recentAttrtion?.currentYearCount ?
                    hiresAndAttritionObjCompanyTwo?.recentAttrtion?.currentYearCount : '0'}}

                  </span>
                  <i class="fa-solid fa-caret-up f-10 mr-1"
                    *ngIf="hiresAndAttritionObjCompanyTwo?.recentAttrtion?.increaseRate && hiresAndAttritionObjCompanyTwo?.recentAttrtion?.currentYearCount"
                    [ngClass]="{ 'fa-rotate-180 mb-1':  hiresAndAttritionObjCompanyTwo?.recentAttrtion?.increaseRate < 0, 'text-danger': hiresAndAttritionObjCompanyTwo?.recentAttrtion?.increaseRate < 0, 'text-success': hiresAndAttritionObjCompanyTwo?.recentAttrtion?.increaseRate > 0 }">
                  </i>
                </p>
                <p class="text-9696 mb-0" style="font-size: 10px;">Recent Attrition (1 Yr) </p>
              </div>
            </div>

          </div>
          <div>
            <div class="text-center">
              <div class="col">


                <div *ngIf="winningTrendsCompanyTwo?.length || loosingTrendsCompanyTwo?.length">
                  <fusioncharts height="450" width="100%" type="stackedcolumn2dline"
                    *ngIf="hireDepartureTalentDataSourceTwo" [dataSource]="hireDepartureTalentDataSourceTwo">
                  </fusioncharts>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="d-flex justify-content-center align-items-center p-2"
      style="background-color: #FBFBFB;border: 1px solid #D9D9D9;">
      <p class="f-14 font-weight-500 mb-0 mr-2">Gender Diversity
        <i class="fa-regular fa-circle-info f-12 custom-tooltip"
          matTooltip="Workforce breakdown by gender, shown as a percentage split to reflect representation."
          [matTooltipClass]="{ 'ai-tooltip text-black': true }"></i>

      </p>
    </div>
    <div class="row">
      <div class="col-6 py-3"
        [ngClass]="{'d-flex justify-content-center align-items-center': !genderChart?.data?.length && !genderCompanyOneLoader}"
        style="border-right: 1px solid #D5DEE6;">
        <div>
          <div class="text-center">
            <div class="col">
              <div *ngIf="!genderChart?.data?.length">
       <div *ngIf="genderCompanyOneLoader">
                <app-comparison-skeleton-loader *ngIf="genderCompanyOneLoader"
                  [type]="'genderLoader'"></app-comparison-skeleton-loader>
              </div>


                <div *ngIf="!genderCompanyOneLoader">
                  <p class="text-center p-5">No Data Available</p>
                </div>
              </div>


              <fusioncharts width="100%" type="doughnut2d" [dataSource]="genderChart" *ngIf="genderChart?.data?.length">
              </fusioncharts>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 py-3"
        [ngClass]="{'d-flex justify-content-center align-items-center': !genderChartCompanyTwo?.data?.length && !genderChartCompanyTwoLoader}">
        <div>
          <div class="text-center">
            <div class="col">
              <div *ngIf="!genderChartCompanyTwo?.data?.length">
       <div *ngIf="genderChartCompanyTwoLoader">
                <app-comparison-skeleton-loader *ngIf="genderChartCompanyTwoLoader"
                  [type]="'genderLoader'"></app-comparison-skeleton-loader>
              </div>
                <div *ngIf="!genderChartCompanyTwoLoader">
                  <p class="text-center p-5">No Data Available</p>
                </div>
              </div>



              <fusioncharts width="100%" type="doughnut2d" [dataSource]="genderChartCompanyTwo"
                *ngIf="genderChartCompanyTwo?.data?.length">
              </fusioncharts>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Locations Overview -->
    <div class="d-flex justify-content-center align-items-center p-2"
      style="background-color: #FBFBFB;border: 1px solid #D9D9D9;">
      <p class="f-14 font-weight-500 mb-0">Locations
        <i class="fa-regular fa-circle-info f-12 custom-tooltip"
          matTooltip="Top 10 employee locations with headcount and percentage to highlight geographic concentration."
          [matTooltipClass]="{ 'ai-tooltip text-black': true }"></i>

      </p>
    </div>
    <div class="row mx-0">
      <div class="col-6 py-3"
        [ngClass]="{'d-flex justify-content-center align-items-center': !topLocationsCompanyOne?.length && !locationCompanyOneLoader}"
        style="border-right: 1px solid #D5DEE6;">
        <div *ngIf="!topLocationsCompanyOne?.length">

  <app-comparison-skeleton-loader *ngIf="locationCompanyOneLoader"
          [type]="'listingLoader'"></app-comparison-skeleton-loader>
          <div *ngIf="!locationCompanyOneLoader">
            <p class="text-center p-5">No Data Available</p>
          </div>
        </div>


        <div class="test" *ngFor="let s of topLocationsCompanyOne | slice: 0:showCountLocations">
          <div class="row mb-2" style="padding: 6px 0px;">
            <div class="col-md-9 d-grid">
              <span class="text-truncate f-12 font-weight-400">{{s.key | titlecase}}</span>
            </div>
            <div class="col font-weight-400 f-12"><span class="mr-1 pointer"
                (click)="handleRedirection('location', s.key, 'companyone')">{{s.doc_count | number}}</span><span
                class="text-9696">{{'('+getCompanyComparePercent(s.doc_count, 'company')+'%)'}}</span></div>
          </div>
        </div>
      </div>
      <div class="col-6 py-3"
        [ngClass]="{'d-flex justify-content-center align-items-center': !topLocationsCompanyTwo?.length && !locationCompanyTwoLoader}">
        <div *ngIf="!topLocationsCompanyTwo?.length">
      <div *ngIf="locationCompanyTwoLoader">
          <app-comparison-skeleton-loader *ngIf="locationCompanyTwoLoader"
            [type]="'listingLoader'"></app-comparison-skeleton-loader>
        </div>


          <div *ngIf="!locationCompanyTwoLoader">
            <p class="text-center p-5">No Data Available</p>
          </div>
        </div>



        <div class="test" *ngFor="let s of topLocationsCompanyTwo | slice: 0:showCountLocations">
          <div class="row mb-2" style="padding: 6px 0px;">
            <div class="col-md-9 d-grid">
              <span class="text-truncate f-12 font-weight-400">{{s.key | titlecase}}</span>
            </div>
            <div class="col font-weight-400 f-12"><span class="mr-1 pointer"
                (click)="handleRedirection('location', s.key, 'companytwo')">{{s.doc_count | number}}</span><span
                class="text-9696">{{'('+getCompanyCompareTwoPercent(s.doc_count, 'company')+'%)'}}</span></div>
          </div>
        </div>
      </div>
    </div>
    <div (click)="toggleShowMore('locations')" class="align-items-center text-center pointer mt-2"
      *ngIf="topLocationsCompanyOne?.length > 5 || topLocationsCompanyTwo?.length > 5">
      <p class="text-webbtree-green f-12 font-weight-400"> {{ showCountLocations === 5 ? 'View More' : 'View Less' }}
      </p>
    </div>

    <!-- Functions Overview -->
    <div class="d-flex justify-content-center align-items-center p-2"
      style="background-color: #FBFBFB;border: 1px solid #D9D9D9;">
      <p class="f-14 font-weight-500 mb-0">Functions
        <i class="fa-regular fa-circle-info f-12 custom-tooltip"
          matTooltip="Most prominent job functions in the company, showing where workforce strength lies."
          [matTooltipClass]="{ 'ai-tooltip text-black': true }"></i>

      </p>
    </div>
    <div class="row mx-0">
      <div class="col-6 py-3"
        [ngClass]="{'d-flex justify-content-center align-items-center': !functionsCompanyOne?.length && !functionCompanyOneLoader}"
        style="border-right: 1px solid #D5DEE6;">
        <div *ngIf="!functionsCompanyOne?.length">
     <div *ngIf="functionCompanyOneLoader">
          <app-comparison-skeleton-loader *ngIf="functionCompanyOneLoader"
            [type]="'listingLoader'"></app-comparison-skeleton-loader>
        </div>
          <div *ngIf="!functionCompanyOneLoader">
            <p class="text-center p-5">No Data Available</p>
          </div>
        </div>


        <div class="test" *ngFor="let s of functionsCompanyOne | slice: 0:showCountFunctions">
          <div class="row mb-2" style="padding: 6px 0px;">
            <div class="col-md-9 d-grid">
              <span class="text-truncate f-12 font-weight-400">{{s.key | titlecase}}</span>
            </div>
            <div class="col font-weight-400 f-12"><span class="mr-1 pointer"
                (click)="handleRedirection('function', s.key, 'companyone')">{{s.doc_count | number}}</span><span
                class="text-9696">{{'('+getCompanyComparePercent(s.doc_count, 'company')+'%)'}}</span></div>
          </div>
        </div>
      </div>
      <div class="col-6 py-3"
        [ngClass]="{'d-flex justify-content-center align-items-center': !functionsCompanyTwo?.length && !functionCompanyTwoLoader}">
        <div *ngIf="!functionsCompanyTwo?.length">

        <div *ngIf="functionCompanyTwoLoader">
          <app-comparison-skeleton-loader *ngIf="functionCompanyTwoLoader"
            [type]="'listingLoader'"></app-comparison-skeleton-loader>
        </div>

          <div *ngIf="!functionCompanyTwoLoader">
            <p class="text-center p-5">No Data Available</p>
          </div>
        </div>

        <div class="test" *ngFor="let s of functionsCompanyTwo | slice: 0:showCountFunctions">
          <div class="row mb-2" style="padding: 6px 0px;">
            <div class="col-md-9 d-grid">
              <span class="text-truncate f-12 font-weight-400">{{s.key | titlecase}}</span>
            </div>
            <div class="col font-weight-400 f-12"><span class="mr-1 pointer"
                (click)="handleRedirection('function', s.key, 'companytwo')">{{s.doc_count | number}}</span><span
                class="text-9696">{{'('+getCompanyCompareTwoPercent(s.doc_count, 'company')+'%)'}}</span></div>
          </div>
        </div>
      </div>
    </div>
    <div (click)="toggleShowMore('functions')" class="align-items-center text-center pointer mt-2"
      *ngIf="functionsCompanyOne?.length > 5 || functionsCompanyTwo?.length > 5">
      <p class="text-webbtree-green f-12 font-weight-400"> {{ showCountFunctions === 5 ? 'View More' : 'View Less' }}
      </p>
    </div>

    <!-- Company winning From -->
    <div class="d-flex justify-content-center align-items-center p-2"
      style="background-color: #FBFBFB;border: 1px solid #D9D9D9;">
      <p class="f-14 font-weight-500 mb-0">Company Winning From
        <i class="fa-regular fa-circle-info f-12 custom-tooltip"
          matTooltip="Top sources of incoming talent, indicating which companies talent is being hired from."
          [matTooltipClass]="{ 'ai-tooltip text-black': true }"></i>
      </p>
    </div>
    <div class="row mx-0">
      <div class="col-6 py-3"
        [ngClass]="{'d-flex justify-content-center align-items-center': !companiesGainingOne?.length && !companyGainingOneLoader}"
        style="border-right: 1px solid #D5DEE6;">
        <div *ngIf="!companiesGainingOne?.length">

        <div *ngIf="companyGainingOneLoader">
          <app-comparison-skeleton-loader *ngIf="companyGainingOneLoader"
            [type]="'listingLoader'"></app-comparison-skeleton-loader>
        </div>
          <div *ngIf="!companyGainingOneLoader">
            <p class="text-center p-5">No Data Available</p>
          </div>
        </div>

        <div class="row mb-2" *ngFor="let company of companiesGainingOne | slice: 0:showCountCompanyWinning">
          <div class="col-md-9">
            <div class="d-flex p-2 w-100 align-items-center">
              <div style="width: 35px; border-right: 1px solid #eceff4;">
                <span class="compnaylogoplaceholder" [ngClass]="{'logobgcolor':!company?.companylogo}">
                  <i class="fas fa-building f-12" *ngIf="!company?.companylogo"></i>
                  <img [src]="company?.companylogo" [alt]="company?.key" *ngIf="company?.companylogo">
                </span>
              </div>



              <p class="f-12 icon-color mb-1 position-relative ml-2" [ngClass]="{'companyHover': company?.website}">
                <span class="" (mouseenter)="getCompanyInfo(company?.key)">
                  <span class="position-relative text-capitalize"
                    [ngClass]="{'dstooltip pointer':company?.website, companyHover: company?.website}">
                    <span class="text-truncate">{{company.key | titlecase}}</span>
                    <span class="dstooltip-content">
                      <app-company-hover-modal [companyInformation]="primaryCompanyInformation"
                        *ngIf="primaryCompanyInformation"></app-company-hover-modal>
                    </span>
                  </span>
                </span>
              </p>
            </div>
          </div>
          <div class="col f-12 d-flex align-items-center font-weight-400">
            <span class="pointer mr-1"
              (click)="handleRedirection('winningtalent', company.key, 'companyone')">{{company.doc_count |
              number}}<span class="text-9696">{{'('+getCompanyComparePercent(company.doc_count,
                'winning')+'%)'}}</span></span>
          </div>
        </div>
      </div>
      <div class="col-6 py-3"
        [ngClass]="{'d-flex justify-content-center align-items-center': !companiesGainingTwo?.length && !companyGainingTwoLoader}">
        <div *ngIf="!companiesGainingTwo?.length">

        <div *ngIf="companyGainingTwoLoader">
          <app-comparison-skeleton-loader *ngIf="companyGainingTwoLoader"
            [type]="'listingLoader'"></app-comparison-skeleton-loader>
        </div>


          <div *ngIf="!companyGainingTwoLoader">
            <p class="text-center p-5">No Data Available</p>
          </div>
        </div>

        <div class="row mb-2" *ngFor="let company of companiesGainingTwo | slice: 0:showCountCompanyWinning">
          <div class="col-md-9">
            <div class="d-flex p-2 w-100  align-items-center">
              <div style="width: 35px; border-right: 1px solid #eceff4;">
                <span class="compnaylogoplaceholder" [ngClass]="{'logobgcolor':!company?.companylogo}">
                  <i class="fas fa-building f-12" *ngIf="!company?.companylogo"></i>
                  <img [src]="company?.companylogo" [alt]="company?.key" *ngIf="company?.companylogo">
                </span>
              </div>



              <p class="f-12 icon-color mb-1 position-relative ml-2" [ngClass]="{'companyHover': company?.website}">
                <span class="" (mouseenter)="getCompanyInfo(company?.key)">
                  <span class="position-relative text-capitalize"
                    [ngClass]="{'dstooltip pointer':company?.website, companyHover: company?.website}">
                    <span class="text-truncate">{{company.key | titlecase}}</span>
                    <span class="dstooltip-content">
                      <app-company-hover-modal [companyInformation]="primaryCompanyInformation"
                        *ngIf="primaryCompanyInformation"></app-company-hover-modal>
                    </span>
                  </span>
                </span>
              </p>
            </div>
          </div>
          <div class="col f-12 d-flex align-items-center">
            <span class="pointer mr-1"
              (click)="handleRedirection('winningtalent', company.key, 'companytwo')">{{company.doc_count |
              number}}<span class="text-9696">{{'('+getCompanyCompareTwoPercent(company.doc_count,
                'winning')+'%)'}}</span></span>
          </div>
        </div>

      </div>
    </div>
    <div (click)="toggleShowMore('companyWinning')" class="align-items-center text-center pointer mt-2"
      *ngIf="companiesGainingOne?.length > 5 || companiesGainingTwo?.length > 5">
      <p class="text-webbtree-green f-12 font-weight-400"> {{ showCountCompanyWinning === 5 ? 'View More' : 'View Less'
        }}
      </p>
    </div>

    <!-- Company losing to -->
    <div class="d-flex justify-content-center align-items-center p-2"
      style="background-color: #FBFBFB;border: 1px solid #D9D9D9;">
      <p class="f-14 font-weight-500 mb-0">Company Losing To
        <i class="fa-regular fa-circle-info f-12 custom-tooltip"
          matTooltip="Companies attracting talent away, helping identify competitors for retention."
          [matTooltipClass]="{ 'ai-tooltip text-black': true }"></i>

      </p>
    </div>
    <div class="row mx-0">
      <div class="col-6 py-3"
        [ngClass]="{'d-flex justify-content-center align-items-center': !companiesLosingOne?.length && !companyLosingLoaderOne}"
        style="border-right: 1px solid #D5DEE6;">
        <div *ngIf="!companiesLosingOne?.length">
       <div *ngIf="companyLosingLoaderOne">
          <app-comparison-skeleton-loader *ngIf="companyLosingLoaderOne"
            [type]="'listingLoader'"></app-comparison-skeleton-loader>
        </div>

          <div *ngIf="!companyLosingLoaderOne">
            <p class="text-center p-5">No Data Available</p>
          </div>
        </div>

        <div class="row mb-2" *ngFor="let company of companiesLosingOne | slice: 0:showCountCompanyLosing">
          <div class="col-md-9">
            <div class="d-flex p-2 w-100 align-items-center">
              <div style="width: 35px; border-right: 1px solid #eceff4;">
                <span class="compnaylogoplaceholder" [ngClass]="{'logobgcolor':!company?.companylogo}">
                  <i class="fas fa-building f-12" *ngIf="!company?.companylogo"></i>
                  <img [src]="company?.companylogo" [alt]="company?.key" *ngIf="company?.companylogo">
                </span>
              </div>



              <p class="f-12 icon-color mb-1 position-relative ml-2" [ngClass]="{'companyHover': company?.website}">
                <span class="" (mouseenter)="getCompanyInfo(company?.key)">
                  <span class="position-relative text-capitalize"
                    [ngClass]="{'dstooltip pointer':company?.website, companyHover: company?.website}">
                    <span class="text-truncate">{{company.key | titlecase}}</span>
                    <span class="dstooltip-content">
                      <app-company-hover-modal [companyInformation]="primaryCompanyInformation"
                        *ngIf="primaryCompanyInformation"></app-company-hover-modal>
                    </span>
                  </span>
                </span>
              </p>
            </div>
          </div>
          <div class="col f-12 d-flex align-items-center font-weight-400">
            <span class="pointer mr-1"
              (click)="handleRedirection('losingtalent', company.key, 'companyone')">{{company.doc_count | number}}<span
                class="text-9696">{{'('+getCompanyComparePercent(company.doc_count, 'loosing')+'%)'}}</span></span>
          </div>
        </div>
      </div>
      <div class="col-6 py-3"
        [ngClass]="{'d-flex justify-content-center align-items-center': !companiesLosingTwo?.length && !companyLosingLoaderTwo}">
        <div *ngIf="!companiesLosingTwo?.length">
    <div *ngIf="companyLosingLoaderTwo">
          <app-comparison-skeleton-loader *ngIf="companyLosingLoaderTwo"
            [type]="'listingLoader'"></app-comparison-skeleton-loader>
        </div>

          <div *ngIf="!companyLosingLoaderTwo">
            <p class="text-center p-5">No Data Available</p>
          </div>
        </div>


        <div class="row mb-2" *ngFor="let company of companiesLosingTwo | slice: 0:showCountCompanyLosing">
          <div class="col-md-9">
            <div class="d-flex p-2 w-100 align-items-center">
              <div style="width: 35px; border-right: 1px solid #eceff4;">
                <span class="compnaylogoplaceholder" [ngClass]="{'logobgcolor':!company?.companylogo}">
                  <i class="fas fa-building f-12" *ngIf="!company?.companylogo"></i>
                  <img [src]="company?.companylogo" [alt]="company?.key" *ngIf="company?.companylogo">
                </span>
              </div>



              <p class="f-12 icon-color mb-1 position-relative ml-2" [ngClass]="{'companyHover': company?.website}">
                <span class="" (mouseenter)="getCompanyInfo(company?.key)">
                  <span class="position-relative text-capitalize"
                    [ngClass]="{'dstooltip pointer':company?.website, companyHover: company?.website}">
                    <span class="text-truncate">{{company.key | titlecase}}</span>
                    <span class="dstooltip-content">
                      <app-company-hover-modal [companyInformation]="primaryCompanyInformation"
                        *ngIf="primaryCompanyInformation"></app-company-hover-modal>
                    </span>
                  </span>
                </span>
              </p>
            </div>
          </div>
          <div class="col f-12 d-flex align-items-center">
            <span class="pointer mr-1"
              (click)="handleRedirection('losingtalent', company.key, 'companytwo')">{{company.doc_count | number}}<span
                class="text-9696">{{'('+getCompanyCompareTwoPercent(company.doc_count, 'loosing')+'%)'}}</span></span>
          </div>
        </div>

      </div>
    </div>
    <div (click)="toggleShowMore('companyLosing')" class="align-items-center text-center pointer mt-2"
      *ngIf="companiesLosingOne?.length > 5 || companiesLosingTwo?.length > 5">
      <p class="text-webbtree-green f-12 font-weight-400"> {{ showCountCompanyLosing === 5 ? 'View More' : 'View Less'
        }}
      </p>
    </div>

    <!-- Seniority -->
    <div class="d-flex justify-content-center align-items-center p-2"
      style="background-color: #FBFBFB;border: 1px solid #D9D9D9;">
      <p class="f-14 font-weight-500 mb-0">Seniority
        <i class="fa-regular fa-circle-info f-12 custom-tooltip"
          matTooltip="Employee distribution across experience levels to understand team structure."
          [matTooltipClass]="{ 'ai-tooltip text-black': true }"></i>

      </p>
    </div>
    <div class="row mx-0">
      <div class="col-6 py-3"
        [ngClass]="{'d-flex justify-content-center align-items-center': !seniorityDataCompanyOne?.data?.length && !seniorityLoaderCompanyOne}"
        style="border-right: 1px solid #D5DEE6;">
        <div *ngIf="!seniorityDataCompanyOne?.data?.length">
          <div *ngIf="!seniorityLoaderCompanyOne">
            <p class="text-center p-5">No Data Available</p>
          </div>
                  <div *ngIf="seniorityLoaderCompanyOne">
          <app-comparison-skeleton-loader *ngIf="seniorityLoaderCompanyOne"
            [type]="'listingLoader'"></app-comparison-skeleton-loader>
        </div>
        </div>



        <div class="test" *ngIf="seniorityDataCompanyOne?.data?.length">
          <fusioncharts type="bar2d" [dataSource]="seniorityDataCompanyOne" width="100%"></fusioncharts>

        </div>
      </div>
      <div class="col-6 py-3"
        [ngClass]="{'d-flex justify-content-center align-items-center': !seniorityDataCompanyTwo?.data?.length && !seniorityLoaderCompanyTwo}">
        <div *ngIf="!seniorityDataCompanyTwo?.data?.length">

      <div *ngIf="seniorityLoaderCompanyTwo">
          <app-comparison-skeleton-loader *ngIf="seniorityLoaderCompanyTwo"
            [type]="'listingLoader'"></app-comparison-skeleton-loader>
        </div>
          <div *ngIf="!seniorityLoaderCompanyTwo">
            <p class="text-center p-5">No Data Available</p>
          </div>
        </div>


        <div class="test" *ngIf="seniorityDataCompanyTwo?.data?.length">
          <fusioncharts type="bar2d" [dataSource]="seniorityDataCompanyTwo" width="100%"></fusioncharts>

        </div>

      </div>
    </div>

    <!-- Jobtitle -->
    <div class="d-flex justify-content-center align-items-center p-2"
      style="background-color: #FBFBFB;border: 1px solid #D9D9D9;">
      <p class="f-14 font-weight-500 mb-0">Job Title
        <i class="fa-regular fa-circle-info f-12 custom-tooltip"
          matTooltip="Most common roles in the organization, offering insight into role-level distribution."
          [matTooltipClass]="{ 'ai-tooltip text-black': true }"></i>

      </p>
    </div>
    <div class="row mx-0">
      <div class="col-6 py-3"
        [ngClass]="{'d-flex justify-content-center align-items-center': !titlesCompanyOne?.length && !titleLoaderOne}"
        style="border-right: 1px solid #D5DEE6;">
        <div *ngIf="!titlesCompanyOne?.length">
          <div *ngIf="!titleLoaderOne">
            <p class="text-center p-5">No Data Available</p>
          </div>
                 <div *ngIf="titleLoaderOne">
          <app-comparison-skeleton-loader *ngIf="titleLoaderOne"
            [type]="'listingLoader'"></app-comparison-skeleton-loader>
        </div>
        </div>


        <div class="test" *ngFor="let s of titlesCompanyOne | slice: 0:showCountJobtitle">
          <div class="row mb-2" style="padding: 6px 0px;">
            <div class="col-md-9 d-grid">
              <span class="text-truncate f-12 font-weight-400">{{s.key | titlecase}}</span>
            </div>
            <div class="col font-weight-400 f-12"><span class="pointer mr-1"
                (click)="handleRedirection('jobtitle', s.key, 'companyone')">{{s.doc_count | number}}</span><span
                class="text-9696">{{'('+getCompanyComparePercent(s.doc_count, 'company')+'%)'}}</span></div>
          </div>
        </div>
      </div>
      <div class="col-6 py-3"
        [ngClass]="{'d-flex justify-content-center align-items-center': !titlesCompanyTwo?.length && !titleLoaderTwo}">
        <div *ngIf="!titlesCompanyTwo?.length">


          <div *ngIf="!titleLoaderTwo">
            <p class="text-center p-5">No Data Available</p>
          </div>
               <div *ngIf="titleLoaderTwo">
          <app-comparison-skeleton-loader *ngIf="titleLoaderTwo"
            [type]="'listingLoader'"></app-comparison-skeleton-loader>
        </div>
        </div>


        <div class="test" *ngFor="let s of titlesCompanyTwo | slice: 0:showCountJobtitle">
          <div class="row mb-2" style="padding: 6px 0px;">
            <div class="col-md-9 d-grid">
              <span class="text-truncate f-12 font-weight-400">{{s.key | titlecase}}</span>
            </div>
            <div class="col font-weight-400 f-12"><span class="mr-1 pointer"
                (click)="handleRedirection('jobtitle', s.key, 'companytwo')">{{s.doc_count | number}}</span><span
                class="text-9696">{{'('+getCompanyCompareTwoPercent(s.doc_count, 'company')+'%)'}}</span></div>
          </div>
        </div>

      </div>
    </div>
    <div (click)="toggleShowMore('jobtitle')" class="align-items-center text-center pointer mt-2"
      *ngIf="titlesCompanyOne?.length > 5 || titlesCompanyTwo?.length > 5">
      <p class="text-webbtree-green f-12 font-weight-400"> {{ showCountJobtitle === 5 ? 'View More' : 'View Less' }}
      </p>
    </div>

    <!-- Ehnicity -->
    <!-- <div class="d-flex justify-content-center align-items-center p-2"
      style="background-color: #FBFBFB;border: 1px solid #D9D9D9;">
      <p class="f-14 font-weight-500 mb-0">Ethnicity
        <i class="fa-regular fa-circle-info f-12 custom-tooltip"
          matTooltip="Ethnic composition of the workforce, presented as a percentage of total employees."
          [matTooltipClass]="{ 'ai-tooltip text-black': true }"></i>

      </p>
    </div> -->
    <!-- <div class="row mx-0">
      <div class="col-6 py-3"
        [ngClass]="{'d-flex justify-content-center align-items-center': !ethnicityChartCompanyOne?.data?.length && !ethnicityLoaderOne}"
        style="border-right: 1px solid #D5DEE6;">
        <div *ngIf="!ethnicityChartCompanyOne?.data?.length">
     <div *ngIf="ethnicityLoaderOne">
          <app-comparison-skeleton-loader *ngIf="ethnicityLoaderOne"
            [type]="'ethnicityLoader'"></app-comparison-skeleton-loader>
        </div>

          <div *ngIf="!ethnicityLoaderOne">
            <p class="text-center p-5">No Data Available</p>
          </div>
        </div>


        <div class="test" *ngIf="ethnicityChartCompanyOne?.data?.length">
          <fusioncharts type="doughnut2d" [dataSource]="ethnicityChartCompanyOne" width="100%"></fusioncharts>

        </div>
          <p class="mb-0 f-10 line-height-1 text-484b59" *ngIf="ethnicityChartCompanyOne?.data?.length">
                <span class="font-weight-600">Disclaimer:</span> This graph shows inferred insights generated using Webbtree's proprietary algorithm, based on available data. While informative, these estimates may not fully reflect the actual characteristics of individuals.
              </p>
      </div>
      <div class="col-6 py-3"
        [ngClass]="{'d-flex justify-content-center align-items-center': !ethnicityChartCompanyTwo?.data?.length && !ethnicityLoaderTwo}">
        <div *ngIf="!ethnicityChartCompanyTwo?.data?.length">

      <div *ngIf="ethnicityLoaderTwo">
          <app-comparison-skeleton-loader *ngIf="ethnicityLoaderTwo"
            [type]="'ethnicityLoader'"></app-comparison-skeleton-loader>
        </div>


          <div *ngIf="!ethnicityLoaderTwo">
            <p class="text-center p-5">No Data Available</p>
          </div>
        </div>


        <div class="test" *ngIf="ethnicityChartCompanyTwo?.data?.length">
          <fusioncharts type="doughnut2d" [dataSource]="ethnicityChartCompanyTwo" width="100%"></fusioncharts>

        </div>
 <p class="mb-0 f-10 line-height-1 text-484b59" *ngIf="ethnicityChartCompanyTwo?.data?.length">
                <span class="font-weight-600">Disclaimer:</span> This graph shows inferred insights generated using Webbtree's proprietary algorithm, based on available data. While informative, these estimates may not fully reflect the actual characteristics of individuals.
              </p>
      </div>
    </div> -->

    <!-- Profiles -->
    <div class="d-flex justify-content-center align-items-center p-2"
      style="background-color: #FBFBFB;border: 1px solid #D9D9D9;">
      <p class="f-14 font-weight-500 mb-0">Profiles
        <i class="fa-regular fa-circle-info f-12 custom-tooltip"
          matTooltip="Recently joined professionals, offering a snapshot of new talent entering the company."
          [matTooltipClass]="{ 'ai-tooltip text-black': true }"></i>

      </p>
    </div>
    <div class="row mx-0">
      <div class="col-6 py-3"
        [ngClass]="{'d-flex justify-content-center align-items-center': !keyPeopleDataCompanyOne?.length && !keyPeopleLoaderCompanyTwo}"
        style="border-right: 1px solid #D5DEE6;">
        <div *ngIf="!keyPeopleDataCompanyOne?.length">

     <div *ngIf="keyPeopleLoaderCompanyTwo">
          <app-comparison-skeleton-loader *ngIf="keyPeopleLoaderCompanyTwo"
            [type]="'listingLoader'"></app-comparison-skeleton-loader>
        </div>

          <div *ngIf="!keyPeopleLoaderCompanyTwo">
            <p class="text-center p-5">No Data Available</p>
          </div>
        </div>


        <div class="test d-flex"
          *ngFor="let candidateDetails of keyPeopleDataCompanyOne | slice: 0: showCountProfiles; let i = index">

          <div>
            <!-- <div class="profilepic">
                <i class="fa-solid fa-user"></i>
            </div> -->
            <div>
              <div class="circular-img mr-3 mb-3 text-capitalize" [ngClass]="'bg-color-' + (i % classCount)">
                {{transform(candidateDetails?.full_name).charAt(0)}}</div>
            </div>
          </div>
          <div>
            <p class="f-12 font-weight-600 mb-1 d-grid" *ngIf="candidateDetails?.full_name">
              <span class="text-truncate" [matTooltip]="candidateDetails?.full_name | titlecase"
                [matTooltipClass]="{ 'red-tooltip text-black': true }">{{candidateDetails?.full_name |
                titlecase}}</span>
            </p>
            <p class="f-12 mb-1 d-grid" *ngIf="candidateDetails?.job_title">
              <span class="text-truncate" [matTooltip]="candidateDetails?.job_title | titlecase"
                [matTooltipClass]="{ 'red-tooltip text-black': true }">{{candidateDetails?.job_title |
                titlecase}}</span>
            </p>
            <div class="f-12 text-9696 d-flex align-items-center">
              <span class="d-flex align-items-baseline" *ngIf="candidateDetails?.currentLocation">
                <div class="d-grid">
                  <span class="text-truncate" [matTooltip]="candidateDetails?.currentLocation | titlecase"
                    [matTooltipClass]="{ 'red-tooltip text-black': true }">
                    {{candidateDetails?.currentLocation | titlecase}}
                  </span>

                </div>
              </span>
              <i class="fa-solid fa-circle mx-2" style="font-size:3px; color: #d9d9d9; margin-top: 0px;"
                *ngIf="candidateDetails?.currentLocation && (candidateDetails?.linkedin_url || candidateDetails?.twitter_url || candidateDetails?.facebook_url)"></i>
              <span class="d-flex" style="width: 55px;">
                <a data-testid="auto-app-company-comparison-overview-a-9" target="_blank" rel="noopener noreferrer"
                  *ngIf="candidateDetails?.linkedin_url && !isBoolean(candidateDetails?.linkedin_url)"
                  (click)="openUrl(candidateDetails?.linkedin_url, 'linkedin')"><i class="fab fa-linkedin"
                    style="color: #2F6DA7!important"></i></a>
                <a data-testid="auto-app-company-comparison-overview-a-10" target="_blank" rel="noopener noreferrer"
                  *ngIf="candidateDetails?.twitter_url && !isBoolean(candidateDetails?.twitter_url)"
                  (click)="openUrl(candidateDetails?.twitter_url, 'twitter')"><i class="fa-brands fa-square-x-twitter mx-2"
                    style="color: #2F6DA7!important"></i></a>
                <a data-testid="auto-app-company-comparison-overview-a-11" target="_blank" rel="noopener noreferrer"
                  *ngIf="candidateDetails?.facebook_url && !isBoolean(candidateDetails?.facebook_url)"
                  (click)="openUrl(candidateDetails?.facebook_url, 'facebook')"><i class="fab fa-facebook"
                    style="color: #2F6DA7!important"></i></a>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 py-3"
        [ngClass]="{'d-flex justify-content-center align-items-center': !keyPeopleDataCompanyTwo?.length && !keyPeopleLoaderCompanyTwo}">
        <div *ngIf="!keyPeopleDataCompanyTwo?.length">

       <div *ngIf="keyPeopleLoaderCompanyTwo">
          <app-comparison-skeleton-loader *ngIf="keyPeopleLoaderCompanyTwo"
            [type]="'listingLoader'"></app-comparison-skeleton-loader>
        </div>

          <div *ngIf="!keyPeopleLoaderCompanyTwo">
            <p class="text-center p-5">No Data Available</p>
          </div>
        </div>


        <div class="test d-flex"
          *ngFor="let candidateDetails of keyPeopleDataCompanyTwo | slice: 0:showCountProfiles; let i = index">

          <div>
            <div>
              <div class="circular-img mr-3 mb-3 text-capitalize" [ngClass]="'bg-color-' + (i % classCount)">
                {{transform(candidateDetails?.full_name).charAt(0)}}</div>
            </div>
          </div>
          <div>
            <p class="f-12 font-weight-600 mb-1 d-grid" *ngIf="candidateDetails?.full_name">
              <span class="text-truncate" [matTooltip]="candidateDetails?.full_name | titlecase"
                [matTooltipClass]="{ 'red-tooltip text-black': true }">{{candidateDetails?.full_name |
                titlecase}}</span>
            </p>
            <p class="f-12 mb-1 d-grid" *ngIf="candidateDetails?.job_title">
              <span class="text-truncate" [matTooltip]="candidateDetails?.job_title | titlecase"
                [matTooltipClass]="{ 'red-tooltip text-black': true }">{{candidateDetails?.job_title |
                titlecase}}</span>
            </p>
            <div class="f-12 text-9696 d-flex align-items-center">
              <span class="d-flex align-items-baseline" *ngIf="candidateDetails?.currentLocation">
                <div class="d-grid">
                  <span class="text-truncate" [matTooltip]="candidateDetails?.currentLocation | titlecase"
                    [matTooltipClass]="{ 'red-tooltip text-black': true }">
                    {{candidateDetails?.currentLocation | titlecase}}
                  </span>
                </div>
              </span>
              <i class="fa-solid fa-circle mx-2" style="font-size:3px; color: #d9d9d9; margin-top: 0px;"
                *ngIf="candidateDetails?.currentLocation && (candidateDetails?.linkedin_url || candidateDetails?.twitter_url || candidateDetails?.facebook_url)"></i>
              <span class="d-flex" style="width: 55px;">
                <a data-testid="auto-app-company-comparison-overview-a-12" target="_blank" rel="noopener noreferrer"
                  *ngIf="candidateDetails?.linkedin_url && !isBoolean(candidateDetails?.linkedin_url)"
                  (click)="openUrl(candidateDetails?.linkedin_url, 'linkedin')"><i class="fab fa-linkedin"
                    style="color: #2F6DA7!important"></i></a>
                <a data-testid="auto-app-company-comparison-overview-a-13" target="_blank" rel="noopener noreferrer"
                  *ngIf="candidateDetails?.twitter_url && !isBoolean(candidateDetails?.twitter_url)"
                  (click)="openUrl(candidateDetails?.twitter_url, 'twitter')"><i class="fa-brands fa-square-x-twitter mx-2"
                    style="color: #2F6DA7!important"></i></a>
                <a data-testid="auto-app-company-comparison-overview-a-14" target="_blank" rel="noopener noreferrer"
                  *ngIf="candidateDetails?.facebook_url && !isBoolean(candidateDetails?.facebook_url)"
                  (click)="openUrl(candidateDetails?.facebook_url, 'facebook')"><i class="fab fa-facebook"
                    style="color: #2F6DA7!important"></i></a>
              </span>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div (click)="toggleShowMore('profiles')" class="align-items-center text-center pointer mt-2"
      *ngIf="keyPeopleDataCompanyOne?.length > 3 || keyPeopleDataCompanyTwo?.length > 3">
      <p class="text-webbtree-green f-12 font-weight-400"> {{ showCountProfiles === 3 ? 'View More' : 'View Less' }}
      </p>
    </div>
  </div>
</div>
<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>
<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
